import { NormalizedLocale } from '@/enums/Locale';

export const updateURLParams = (
	searchParams: URLSearchParams,
	paramsToUpdate: Record<string, string | null>,
): URLSearchParams => {
	const updatedParams = new URLSearchParams(searchParams);

	Object.entries(paramsToUpdate).forEach(([key, value]) => {
		!value ? updatedParams.delete(key) : updatedParams.set(key, value);
	});

	return updatedParams;
};

export const prependLocaleToPath = (route: string, locale?: NormalizedLocale): string => {
	if (!locale) return route;

	const normalizedRoute = route.replace(/^\/+|\/+$/g, '');

	return normalizedRoute ? `/${locale}/${normalizedRoute}` : `/${locale}`;
};

export const getRequestQuoteUrl = (baseUrl: string, sku: string, productName?: string): string => {
	if (!sku) return baseUrl;

	const params = {
		seriesModel: 'seriesModel',
		message: 'message',
	};

	try {
		const url = new URL(baseUrl);

		url.searchParams.set(params.seriesModel, sku);

		const messageParts = [
			'Hello,',
			'',
			'I am interested in receiving a quote for the following product:',
			`- Product Name: ${productName || '<product_name>'}`,
			`- SKU: ${sku || '<sku>'}`,
			'',
			'[Add your comments here]',
		];

		const message = messageParts.join('\n');
		url.searchParams.set(params.message, message);

		return url.toString();
	} catch (error) {
		console.error('Failed to build request quote URL:', error);
		return baseUrl;
	}
};
